import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import Contact from '../Contact/Contact';

function ContactList({ contacts, onChangeConversation }) {
  return (
    <>
      {contacts.map((user) => (
        <Contact key={uuidv4()} user={user} onChangeConversation={onChangeConversation} />
      ))}
    </>
  );
}

ContactList.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.any.isRequired).isRequired,
  onChangeConversation: PropTypes.func.isRequired,
};

export default ContactList;
